export default {
    data: function() {
        return {
            destacadoCarouselConfig: {
                autoplay: true,
                autoplaySpeed: 3000,
                centerMode: true,
                dots: false,
                infinite: true,
                mobileFirst: true,
                navButtons: false,
                pauseOnHover: false,
                speed: 1500,
                slidesToShow: 3,
                timing: 'ease',
                responsive: [{
                        breakpoint: 500,
                        settings: { slidesToShow: 2 },
                    },
                    {
                        breakpoint: 769,
                        settings: { slidesToShow: 3 },
                    },
                    {
                        breakpoint: 1024,
                        settings: { slidesToShow: 5 },
                    },
                ],
            },
        }
    },
    computed: {
        destacados() {
            return this.$page.props.destacados
        },
    },
}